import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/index.css";
import { applyMiddleware, createStore } from "redux";
import rootReducer from "./modules/rootReducer";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import GlobalStyle from "./styles/GlobalStyle";

const reduxStore = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={reduxStore}>
      <GlobalStyle />
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
